import React, { useState, useEffect } from 'react';
import { getAuditTrail } from '../services/api';
import { formatDate } from '../utils/formatDate';
import './TenderList.css';

const SOURCE_LABELS = {
  tender: 'Tender',
  technical_bid: 'Technical Bid',
  financial_bid: 'Price Bid',
};

function AllAuditTrailList() {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sourceFilter, setSourceFilter] = useState('');

  const fetchAudits = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getAuditTrail(500);
      if (res.success) setAudits(res.audits || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAudits();
  }, []);

  const filtered = sourceFilter
    ? audits.filter((a) => a.source === sourceFilter)
    : audits;

  return (
    <div className="tender-list-container">
      <div className="tender-list-header">
        <div className="header-title">
          <h2>All Audit Trail</h2>
          <p>Combined activity from tenders, technical bids, and price bids</p>
        </div>
      </div>

      {error && (
        <div className="error-message">
          {error}
          <button type="button" onClick={() => setError(null)}>×</button>
        </div>
      )}

      <div className="filters-section">
        <select
          value={sourceFilter}
          onChange={(e) => setSourceFilter(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #d1d5db' }}
        >
          <option value="">All sources</option>
          <option value="tender">Tender</option>
          <option value="technical_bid">Technical Bid</option>
          <option value="financial_bid">Price Bid</option>
        </select>
        <button
          type="button"
          className="link-btn"
          onClick={fetchAudits}
          disabled={loading}
          style={{ marginLeft: '12px' }}
        >
          Refresh
        </button>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner" />
          <p>Loading audit trail...</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <h3>No audit entries</h3>
          <p>
            {sourceFilter
              ? `No entries for source "${SOURCE_LABELS[sourceFilter] || sourceFilter}"`
              : 'Activity will appear here as users perform actions'}
          </p>
        </div>
      ) : (
        <div className="tenders-table-wrapper">
          <table className="tenders-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Source</th>
                <th>Ref / Entity</th>
                <th>Action</th>
                <th>User</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((a) => (
                <tr key={`${a.source}-${a.id}-${a.created_at}`}>
                  <td>{formatDate(a.created_at)}</td>
                  <td>
                    <span className="status-badge status-default">
                      {SOURCE_LABELS[a.source] || a.source || '–'}
                    </span>
                  </td>
                  <td>{a.tender_ref || a.entity_id || a.technical_bid_id || a.financial_bid_id || '–'}</td>
                  <td>{a.action || '–'}</td>
                  <td>{a.performed_by_name || a.performed_by_id || '–'}</td>
                  <td>
                    <span className="tender-title-inline" title={a.details || ''}>
                      {a.details || a.previous_value != null || a.new_value != null
                        ? [a.details, a.previous_value != null && a.new_value != null ? `${a.previous_value} → ${a.new_value}` : null].filter(Boolean).join(' · ') || '–'
                        : '–'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && filtered.length > 0 && (
        <div className="list-footer">
          <span>Showing {filtered.length} audit entr{filtered.length === 1 ? 'y' : 'ies'}</span>
        </div>
      )}
    </div>
  );
}

export default AllAuditTrailList;
